import { useNavigate } from 'react-router-dom';
import { useSite } from '../data/SiteContext';

export default function Blog() {
  const navigate = useNavigate();
  const { posts } = useSite();
  return (
    <div className="wrap" style={{ paddingTop:40, paddingBottom:72 }}>
      <div className="kicker">Travel guides</div>
      <h1 className="page-h1">Tips from the team</h1>
      <p className="page-sub">Practical guides, honest advice and inspiration for your next escape.</p>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))', gap:24 }}>
        {posts.map(b => (
          <div key={b.title} onClick={() => navigate(`/blog/${b.slug}`)} className="card lift3" style={{ cursor:'pointer', borderRadius:22, overflow:'hidden', boxShadow:'0 10px 26px rgba(16,90,90,0.09)' }}>
            <div style={{ height:200 }}><div className="bgimg" style={{ backgroundImage:`url(${b.img})` }}></div></div>
            <div style={{ padding:22 }}>
              <div style={{ fontSize:12, fontWeight:700, color:'#0e9c86', textTransform:'uppercase', letterSpacing:'.06em' }}>{b.cat} · {b.mins} min read</div>
              <div className="serif" style={{ fontSize:23, margin:'8px 0 8px', lineHeight:1.2 }}>{b.title}</div>
              <div style={{ fontSize:14.5, color:'#5a726f', lineHeight:1.55, marginBottom:10 }}>{b.excerpt}</div>
              <div style={{ fontSize:13, color:'#9aa6a3' }}>{b.date}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
